import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { Order } from "modules/charts-shared";
import { useMutation, useQueryClient } from "react-query";

type IvMedicationSection = {
  code: string;
  answers: { qCode: string; value: string }[];
  createdDate: string;
  createdById: string;
  orderId: string;
  order?: Order;
};

type TriageIvMedicationResponse = {
  ivStarts: IvMedicationSection[];
  ivMedications: IvMedicationSection[];
  medications: IvMedicationSection[];
  treatments: IvMedicationSection[];
  treatmentsIvStarts: IvMedicationSection[];
  lastSnapshotCreatedAt: string | null;
};

function useIvAndMedication(encounterId: string) {
  return useAxiosQuery(["ivAndMedication", { encounterId }], () =>
    axiosChartInstance.get<TriageIvMedicationResponse>(
      `v1/triage/iv-medication/${encounterId}`
    )
  );
}

function useRefetchIvAndMedication(encounterId: string) {
  const queryClient = useQueryClient();

  return useMutation(
    async () =>
      queryClient.fetchQuery(["ivAndMedication", { encounterId }], () =>
        axiosChartInstance.get<TriageIvMedicationResponse>(
          `v1/triage/iv-medication/${encounterId}`
        )
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          "ivAndMedicationCounters",
          { encounterId },
        ]);
        queryClient.invalidateQueries(["medsAndIvCounters", { encounterId }]);
        queryClient.invalidateQueries(["treatmentsCounters", { encounterId }]);
      },
    }
  );
}

export { useIvAndMedication, useRefetchIvAndMedication };
export type { TriageIvMedicationResponse, IvMedicationSection };
